import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function AccountsAdminDashboard() {
  return (
    <Dashboard sidebarType="DGM Accounts">
      <DashboardConfig />
    </Dashboard>
  );
}
